import Tablexxx from "../Tablexxx"
import { buttons, columnsTracking } from "./configxx";

const Tabsperc = ({ setComponent, setShow, setRow }) => {
  return (
    <Tablexxx
      columns={columnsTracking}
      URL={"cargosporareaserietipo?sorts=-REGSTAMP&groups=EMPNITXX,CARIDXXX"}
      buttons={buttons}
      setComponent={setComponent}
      setShow={setShow}
      setRow={setRow}
    />
  )
}

export default Tabsperc;
